import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {articlePickerView_template} from "./articlePickerView_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { multipleSelector_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {filterTag_template} from "./filterTag_template";
import { validationsList_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";


declare var ko: any;

export class articlePicker_template extends vnTemplate {

    protected parent: any;
    protected target: any;
    public articlePickerView: articlePickerView_template;
    protected articleSearchFilter: filterSimple_template;
    protected networkCategoryFilter : multipleSelector_template;
    protected contentTypeFilter : multipleSelector_template;
    protected categoryFilter : multipleSelector_template;
    protected classificationFilter : filterDropdown_template;
    public articlePagination: pagination_template;
    protected articleLoadEnable;
    protected articleNextPageRequested;
    protected validationTemplate: validationsList_template;

    protected intentFilter : multipleSelector_template
    protected tagFilter : filterTag_template;

    protected getTemplateHtml(): string {

        return /* html */`
            <div class="w-lightbox w-picker article-picker" data-bind="css: { 'is-visible': isShown }" >

               <div class="picker-group" data-bind="css: { 'is-activated': selectedArticles().length > 0 }">
                    <div class="picker-group-in">
                        <div class="picker-group-header w-justify">
                            <div class="w-left">
                                <strong class="section-title" data-bind="text: 'Article Group (' + selectedArticles().length + ')'"></strong>
                            </div>
                            <div class="w-right">
                                <button type="button" class="btn insert-group icon i-ins" data-bind="event: { click: onClickInsertGroup }, css: { 'is-disable': selectedArticles().length < 2 }">Insert</button>
                            </div>
                        </div>

                        <div class="picker-group-body">
                            <div class="w-picker-list">
                                <ul class="picker-list sortable article-group-sortable" style="height: auto;" data-bind="foreach: selectedArticles">

                                    <li class="picker-item icon" draggable="true" data-bind="attr: { id : 'article-group-' + id }, click: $parent.onClickViewFromGroup, clickBubble: false">
                                        <div class="btn reorder only-icon icon i-move i-drag"><span class="hidden-text">move</span></div>
                                        <button class="btn deselect only-icon icon i-deselect" title="remove article" type="button" data-bind="click: $parent.onClickDeleteSelectedArticle, clickBubble: false"><span class="hidden-text">deselect</span></button>

                                        <div class="w-img" data-bind="visible: image != null">
                                            <div class="ratio-content">
                                                <img data-bind="attr: { src: image != null ? image.url : '' }">
                                            </div>
                                        </div>
                                        <div class="w-info">
                                            <strong data-bind="text: title"></strong>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="lightbox-content picker" id="article-picker">

                    <div class="picker-header w-justify">

                        <div class="w-left">
                        </div>

                        <div class="w-center">
                            <span class="picker-header-title icon i-article">Article Search</span>
                            <span class="picker-header-title"data-bind="text: sectionTitleOverride()"></span>
                        </div>

                        <div class="w-right">
                            <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel }"></button>
                        </div>

                    </div>

                    <div class="picker-body">


                         <div class="list-header">
                            <div class="w-justify" style="margin-bottom: 1rem">
                                <div class="w-left" >
                                    ${ this.categoryFilter.getHtmlBuild() }
                                    ${ this.contentTypeFilter.getHtmlBuild() }
                                    ${ this.networkCategoryFilter.getHtmlBuild() }
                                    ${ this.intentFilter.getHtmlBuild() }
                                </div>
                            </div>

                            <div class="w-justify" style="margin-bottom: 1rem">
                                <div class="w-left" >
                                    <label class="form-label form-label-box" style="margin: -1.5rem 0 0 2rem;">Classification</label>
                                    ${ this.classificationFilter.getHtmlBuild() }
                                    ${ this.tagFilter.getHtmlBuild() }
                                </div>
                            </div>

                            <div class="w-justify" style="margin-bottom: 0">
                                <div class="w-center">
                                    ${this.articleSearchFilter.getHtmlBuild()}
                                </div>
                            </div>
                         </div>

                         <div class="selected-filters">
                            <div id="selected-categories"></div>
                            <div id="selected-content_types"></div>
                            <div id="selected-network_categories"></div>
                            <div id="selected-classifications"></div>
                            <div id="selected-intents"></div>
                            <div id="selected-tags"></div>
                        </div>

                        <div class="w-double-list-scroll" id="article-full-results-list">


                                <div class="w-picker-list w-related-picker-list is-hidden" id="related-article-results-list">
                                    <span class="list-title icon i-ai-1">suggested articles</span>
                                    <!--<div class="w-msg" data-bind="css: { 'is-text-visible': relatedArticles().length == 0}">
                                        <p>No Results Found</p>
                                    </div>-->

                                    <ul class="picker-list" id="related-article-picker-list" data-bind="foreach: relatedArticles">

                                        <li class="picker-item related icon" data-bind="css: { 'is-best': originalScore && originalScore >= 0.7, 'is-selected': $data.selected }">

                                            <button class="btn-zone view" title="view article" type="button" data-bind="event: { click: $parent.onClickView }" ><span>view article</span></button>
                                            <button class="btn-zone select" title="select article" type="button" data-bind="event: { click: $parent.onClickSelectArticle }" ><span>select article</span></button>
                                            <button class="btn-zone icon i-insert-link" style="right: 6px; bottom: 6px; z-index: 69; font-size: 16px;" title="Insert Hyperlink" type="button" data-bind="visible: $parent.showHyperlink, event: { click: $parent.onClickQuickInsertHyperlink }" ><span>insert link</span></button>
                                            <button type="button" class="btn-zone icon i-link" style="right: 36px; bottom: 6px; z-index: 69; font-size: 16px; opacity: 0.5" title="Open Article" data-bind="event: { click: $parent.onClickViewOnSite }"></button>
                                            <span class="btn-zone similarity icon" style="left: 10px; bottom: 2px; z-index: 69; font-size: 16px; opacity: 0.5" data-bind="text: score"></span>
                                            <div class="" data-bind="css: { 'w-img' : imageUrl != null }">
                                                <!-- ko if: imageUrl != null -->
                                                    <div class="ratio-content">
                                                        <img data-bind="attr: { src: imageUrl }">
                                                    </div>
                                                    <div data-bind="attr: { 'class': idFeaturedVideo != null ? 'premium-logo icon i-premium i-' + $parent.brand().shortName : '' }"></div>
                                                <!-- /ko -->

                                            </div>
                                            <div class="w-info">
                                                <strong data-bind="text: title"></strong>
                                                <span data-bind="text: dateLastPublish"></span>
                                                <span class="details first" data-bind="html: '<span>Active Sessions: ' + ($data.activeSessions ? '<strong>' + $data.activeSessions.toLocaleString() + '</strong></span>' : 'N/A</span>')"></span>
                                                <span class="details" data-bind="html: '<span>Recent Sessions: ' + ($data.recentSessions7Days ? '<strong>' + $data.recentSessions7Days.toLocaleString() + '</strong></span>' : 'N/A</span>')"></span>

                                            </div>

                                        </li>

                                    </ul>
                                    <button type="button" id="show-more-btn" class="btn secondary" data-bind="event: { click: onClickShowMore }">show more</button>
                                </div>

                                <!--
                                <div class="w-picker-list w-related-picker-list is-hidden" id="new-model-article-results-list">
                                    <span class="list-title icon i-ai-1">new model suggestions</span>

                                    <ul class="picker-list" id="new-model-article-picker-list" data-bind="foreach: newModelArticles">

                                        <li class="picker-item related icon" data-bind="css: { 'is-best': originalScore && originalScore >= 0.7, 'is-selected': $data.selected }">

                                            <button class="btn-zone view" title="view article" type="button" data-bind="event: { click: $parent.onClickView }" ><span>view article</span></button>
                                            <button class="btn-zone select" title="select article" type="button" data-bind="event: { click: $parent.onClickSelectArticle }" ><span>select article</span></button>
                                            <button class="btn-zone icon i-insert-link" style="right: 6px; bottom: 6px; z-index: 69; font-size: 16px;" title="Insert Hyperlink" type="button" data-bind="visible: $parent.showHyperlink, event: { click: $parent.onClickQuickInsertHyperlink }" ><span>insert link</span></button>
                                            <button type="button" class="btn-zone icon i-link" style="right: 36px; bottom: 6px; z-index: 69; font-size: 16px; opacity: 0.5" title="Open Article" data-bind="event: { click: $parent.onClickViewOnSite }"></button>
                                            <span class="btn-zone similarity icon" style="left: 10px; bottom: 2px; z-index: 69; font-size: 16px; opacity: 0.5" data-bind="text: score"></span>
                                            <div class="" data-bind="css: { 'w-img' : imageUrl != null }"> -->
                                            
                                            <!--
                                            <div class="w-info">
                                                <strong data-bind="text: title"></strong>
                                                <span data-bind="text: dateLastPublish"></span>
                                                <span class="details first" data-bind="html: '<span>Active Sessions: ' + ($data.activeSessions ? '<strong>' + $data.activeSessions.toLocaleString() + '</strong></span>' : 'N/A</span>')"></span>
                                                <span class="details" data-bind="html: '<span>Recent Sessions: ' + ($data.recentSessions7Days ? '<strong>' + $data.recentSessions7Days.toLocaleString() + '</strong></span>' : 'N/A</span>')"></span>

                                            </div>

                                        </li>

                                    </ul>
                                    <button type="button" id="new-model-show-more-btn" class="btn secondary" data-bind="event: { click: onClickShowMoreNewModel }">show more</button>
                                </div> -->
                            



                            <div class="w-picker-list" id="article-results-list">



                                <!--<div class="w-msg article" data-bind="css: { 'is-text-visible': articles().length == 0}">
                                    <p>No Results Found</p>
                                </div>-->

                                <ul class="picker-list" id="article-picker-list" data-bind="foreach: articles">

                                    <li class="picker-item icon" data-bind="css: { 'is-selected': $data.selected }">

                                        <button class="btn-zone view" title="view article" type="button" data-bind="event: { click: $parent.onClickView }" ><span>view article</span></button>
                                        <button class="btn-zone select" title="select article" type="button" data-bind="event: { click: $parent.onClickSelectArticle }" ><span>select article</span></button>
                                        <button class="btn-zone icon i-insert-link" style="right: 6px; bottom: 6px; z-index: 69; font-size: 16px;" title="Insert Hyperlink" type="button" data-bind="visible: $parent.showHyperlink, event: { click: $parent.onClickQuickInsertHyperlink }" ><span>insert link</span></button>
                                        <button type="button" class="btn-zone icon i-link" style="right: 36px; bottom: 6px; z-index: 69; font-size: 16px; opacity: 0.5" title="Open Article" data-bind="event: { click: $parent.onClickViewOnSite }"></button>

                                        <div class="" data-bind="css: { 'w-img' : imageUrl != null }">
                                            <!-- ko if: imageUrl != null -->
                                                <div class="ratio-content">
                                                    <img data-bind="attr: { src: imageUrl }">
                                                </div>
                                                <div data-bind="attr: { 'class': idFeaturedVideo != null ? 'premium-logo icon i-premium i-' + $parent.brand().shortName : '' }"></div>
                                            <!-- /ko -->

                                        </div>
                                        <div class="w-info">
                                            <strong data-bind="text: title"></strong>
                                            <span data-bind="text: dateLastPublish"></span>
                                        </div>

                                    </li>

                                </ul>

                            </div>
                         </div>
                    </div>

                    ${this.articlePickerView.getHtmlBuild()}
                </div>
            </div>

            `;
    }

    protected getTemplateName(): string {
        return "articlePicker-template";
    }

    protected buildViewModel(): any {

        this.validationTemplate = this.caller.validationTemplate;

        //create observable array refresh function
        ko.observableArray.fn.refresh = function (item, index) {
            if (index==null) index = this['indexOf'](item);
            if (index >= 0) {
                this.splice(index, 1, ko.utils.extend({}, item)) // create new item
            }
        }

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {
            isShown: ko.observable(false),
            articles: ko.observableArray([]),
            relatedArticles: ko.observableArray([]),
            relatedArticlesFull: ko.observableArray([]),
            newModelArticles: ko.observableArray([]),
            newModelArticlesFull: ko.observableArray([]),
            brand: ko.observable(''),
            brandOverride: ko.observable(null),
            sectionTitleOverride: ko.observable(''),
            articleRecommendationIndex: ko.observable(null),
            selectedCategories: ko.observableArray([]),
            selectedContentTypes: ko.observableArray([]),
            selectedNetworkCategories: ko.observableArray([]),
            selectedArticles: ko.observableArray([]),
            articleGroupElement: ko.observable(null),
            articleGroupArticleElements: ko.observable([]),
            onClickCancel: function(data, event){ huit_neuf_this.onClickCancel();},
            onClickShowMore: function(data, event){ huit_neuf_this.onClickShowMore();},
            onClickShowMoreNewModel: function(data, event){ huit_neuf_this.onClickShowMoreNewModel();},
            onClickView: function(data, event){ huit_neuf_this.onClickView(data);},
            onClickViewOnSite: function(data, event){ huit_neuf_this.onClickViewOnSite(data.permalink);},
            onClickQuickInsertHyperlink: function(data, event){ huit_neuf_this.onClickQuickInsertHyperlink(data);},
            onClickSelectArticle: function(data, event){ huit_neuf_this.onClickSelectArticle(data);},
            onClickInsertGroup: function(data, event){ huit_neuf_this.onClickInsertGroup();},
            onClickViewFromGroup: function(data, event){ huit_neuf_this.onClickViewFromGroup(data);},
            onClickDeleteSelectedArticle: function(data, event){ huit_neuf_this.deselectArticle(data);},
            showHyperlink: ko.pureComputed(() => {
                return huit_neuf_this.articlePickerView.getIsHyperlinkModeEnabled();
            }),
        };
    }

    protected initPartial(): void {

        this.articleSearchFilter = new filterSimple_template("articleSearchFilter", this.getTemplateViewModel(), this);
        this.articleSearchFilter.getTemplateViewModel().filterKeyword('');

        this.networkCategoryFilter = new multipleSelector_template("networkCategoryFilter", this.getTemplateViewModel(), this.caller);
        this.networkCategoryFilter.setLabel("network category");
        this.networkCategoryFilter.setFilterContainerClass('margin-neg');
        this.networkCategoryFilter.setTagContainerId('selected-network_categories');
        this.networkCategoryFilter.setTagContainerCaption('Selected network categories:');

        this.contentTypeFilter = new multipleSelector_template("contentTypeFilter", this.getTemplateViewModel(), this.caller);
        this.contentTypeFilter.setLabel("content type");
        this.contentTypeFilter.setFilterContainerClass('margin-neg');
        this.contentTypeFilter.setTagContainerId('selected-content_types');
        this.contentTypeFilter.setTagContainerCaption('Selected content types:');

        this.categoryFilter = new multipleSelector_template("categoryFilter", this.getTemplateViewModel(), this.caller);
        this.categoryFilter.setLabel("category");
        this.categoryFilter.setFilterContainerClass('margin-neg');
        this.categoryFilter.setTagContainerId('selected-categories');
        this.categoryFilter.setTagContainerCaption('Selected categories:');

        this.classificationFilter = new filterDropdown_template("classificationFilter", this.getTemplateViewModel(), this.caller);
        this.classificationFilter.setLabel("classification");

        this.articlePagination = new pagination_template("articlePagination", this.getTemplateViewModel(), this.caller);
        this.articlePagination.getTemplateViewModel().itemPerPage = 54 ;

        this.intentFilter = new multipleSelector_template("intentFilter", this.getTemplateViewModel(), this.caller);
        this.intentFilter.setLabel("intent");
        this.intentFilter.setFilterContainerClass('margin-neg');
        this.intentFilter.setTagContainerId('selected-intents');
        this.intentFilter.setTagContainerCaption('Selected intents:');

        this.tagFilter = new filterTag_template("tagFilter", this.getTemplateViewModel(), this.caller);
        this.tagFilter.asMultipleSelectionMode();

        this.articlePickerView = new articlePickerView_template("articlePickerView", this.getTemplateViewModel(), this.caller);
        this.articlePickerView.setParent(this);
    }

    public showArticlePicker(target, filterKeyword = null): void {

        if(!filterKeyword){
            this.articleSearchFilter.clearInput();
        }
        this.setTarget(target);
        this.clearGroupState();
        this.articleSearchFilter.setFilterKeyword(filterKeyword);
        this.show();
        this.articlePickerView.restPageValues();
        this.articlePickerView.setTitleOverride(filterKeyword);
        this.fillPage();

        this.caller.searchRelatedVectorArticles(target);
        // New model suggestions disabled for launch until model switching is fully enabled.
        // this.caller.searchNewModelVectorArticles(target);
    }

    public showArticlePickerForExternalRecommendations(idBrand, brandShortName, index): void {

        this.getTemplateViewModel().brandOverride(idBrand);
        this.getTemplateViewModel().sectionTitleOverride(' - ' + brandShortName);
        this.getTemplateViewModel().articleRecommendationIndex(index);
        this.articleSearchFilter.clearInput();

        this.setTarget(null);
        this.show();
        this.articlePickerView.restPageValues();
        this.fillPage();
        this.caller.searchRelatedVectorArticles();
        // New model suggestions disabled for launch until model switching is fully enabled.
        // this.caller.searchNewModelVectorArticles();
    }

    public setTarget(target){

        this.target = target;
    }

    public getBrand(){

        return this.getTemplateViewModel().brand();
    }

    public setBrand(brand){
        this.getTemplateViewModel().brand(brand);
    }

    public getTarget(){

        return this.target;
    }

    public show(){

        if(!document.body.classList.contains("is-fixed")){

            document.body.classList.add("is-fixed");
        }
        this.getTemplateViewModel().articles([]);
        this.resetPagination();
        this.articlePickerView.getTemplateViewModel().articleElement(null);
        this.getTemplateViewModel().isShown(true);
    }

    public hide(){

        document.body.classList.remove("is-fixed");
        this.getTemplateViewModel().isShown(false);
        this.clearGroupState();
    }

    public fillPage(){
        this.caller.getArticleReportList();
    }

    protected onClickCancel(){

        this.hide();
        this.hideLoading();
        this.clearGroupState();
        this.caller.cancelAndResetFetchRequest('getArticleReportList');
    }

     protected onClickShowMore(){

        document.getElementById("show-more-btn").classList.add("is-hidden");
        let relatedArticlesFull = this.getTemplateViewModel().relatedArticlesFull();
        this.getTemplateViewModel().relatedArticles([]);
        this.getTemplateViewModel().relatedArticles(relatedArticlesFull);
    }

     protected onClickShowMoreNewModel(){

        document.getElementById("new-model-show-more-btn").classList.add("is-hidden");
        let newModelArticlesFull = this.getTemplateViewModel().newModelArticlesFull();
        this.getTemplateViewModel().newModelArticles([]);
        this.getTemplateViewModel().newModelArticles(newModelArticlesFull);
    }

    public setCaller(caller){
        this.caller = caller;
        this.articleSearchFilter.caller = caller;
        this.categoryFilter.caller = caller;
        this.contentTypeFilter.caller = caller;
        this.networkCategoryFilter.caller = caller;
        this.classificationFilter.caller = caller;
        this.intentFilter.caller = caller;
        this.tagFilter.caller = caller;
        this.articlePagination.caller = caller;
        this.articlePickerView.caller = caller;
        this.caller.getArticleReferences();
    }

    public setNetworkCategoryFilterItems(groupCategories){

        let groups = [];
        for ( let groupCategory of groupCategories){

            groups.push({"name" : groupCategory.name, "items" :groupCategory.networkCategories});
        }
        this.networkCategoryFilter.setMultiSectionItems(groups);
    }
    public setContentTypeFilterItems(items){

        this.contentTypeFilter.setItems(items);
    }

    public setCategoryFilterItems(items){

        this.categoryFilter.setItems(items);
    }

    public setIntentFilterItems(items){
        this.intentFilter.setItems(items);
    }

    public setClassificationFilterItems(options){
        const defaultOption = this.classificationFilter.getTemplateViewModel().options() // All
        const allOptions = [...defaultOption, ...options];
        this.classificationFilter.setOptions(allOptions);
    }

    public showLoading(){

        let list = document.getElementById("article-picker-list");
        list.classList.add("loading")
    }

    public hideLoading(){

        let list = document.getElementById("article-picker-list");
        list.classList.remove("loading")
    }

    public showFullLoading(){

        let list = document.getElementById("article-picker");
        list.classList.add("loading")
    }

    public hideFullLoading(){

        let list = document.getElementById("article-picker");
        list.classList.remove("loading")
    }

    public showRelatedLoading(){

        let list = document.getElementById("related-article-picker-list");
        list.classList.add("loading")
    }

    public hideRelatedLoading(){

        let list = document.getElementById("related-article-picker-list");
        list.classList.remove("loading")
    }

    public showNewModelLoading(){

        let list = document.getElementById("new-model-article-picker-list");
        list.classList.add("loading")
    }

    public hideNewModelLoading(){

        let list = document.getElementById("new-model-article-picker-list");
        list.classList.remove("loading")
    }

    public getViewModelForRequest(){
        //if classification filter is null
        let filterClassification = this.getTemplateViewModel().classificationFilter.selectedOption() === null
            ? []
            : [this.getTemplateViewModel().classificationFilter.selectedOption()];


        return {
            pagination: this.getTemplateViewModel().articlePagination,
            filters      : {
                keywords: this.getTemplateViewModel().articleSearchFilter.filterKeyword,
                networkCategory: this.getTemplateViewModel().networkCategoryFilter.selectedItems,
                contentType: this.getTemplateViewModel().contentTypeFilter.selectedItems,
                category: this.getTemplateViewModel().categoryFilter.selectedItems,
                classification: filterClassification,
                publishStatus: [3, 'Republished', 'Scheduled Republish'],
                intent : this.getTemplateViewModel().intentFilter.selectedItems,
                showAllArticles: true,
                tags: this.tagFilter.getTagsForRequest(),
            },
        }
    }

    public getKeyword(){

        return this.getTemplateViewModel().articleSearchFilter.filterKeyword();
    }

    public setArticles(articleResults: Array<{ title: string, dateLastPublish: string, imageUrl: string , excerpt: string}>): void {

        if(this.getTemplateViewModel().articlePagination.pageNumber() == 1){
            this.getTemplateViewModel().articles([])
        }
        if(articleResults.length > 0) {
            let articles = this.getTemplateViewModel().articles().concat(articleResults);
            this.getTemplateViewModel().articles(articles);

            this.articleNextPageRequested = false;
            if (!this.articleLoadEnable) {
                this.enableArticlePickerWaypoint();
            }
        }
        if (this.getTemplateViewModel().selectedArticles().length > 0) {
            this.refreshArticleResults();
        }
    }

    public setRelatedArticles(articleResults): void {

        articleResults = this.convertIfObjectOfObjects(articleResults);
        document.getElementById("show-more-btn").classList.remove("is-hidden");
        document.getElementById("show-more-btn").classList.remove("is-disable");
        this.getTemplateViewModel().relatedArticles([]);
        this.getTemplateViewModel().relatedArticlesFull([]);
        if(articleResults && articleResults.length > 0) {
            this.getTemplateViewModel().relatedArticles(articleResults.slice(0, 4));
            this.getTemplateViewModel().relatedArticlesFull(articleResults);
        }
        if (this.getTemplateViewModel().selectedArticles().length > 0) {
            this.refreshArticleResults();
        }
    }

    public setNewModelArticles(articleResults): void {

        articleResults = this.convertIfObjectOfObjects(articleResults);
        document.getElementById("new-model-show-more-btn").classList.remove("is-hidden");
        document.getElementById("new-model-show-more-btn").classList.remove("is-disable");
        this.getTemplateViewModel().newModelArticles([]);
        this.getTemplateViewModel().newModelArticlesFull([]);
        if(articleResults && articleResults.length > 0) {
            this.getTemplateViewModel().newModelArticles(articleResults.slice(0, 4));
            this.getTemplateViewModel().newModelArticlesFull(articleResults);
        }
        if (this.getTemplateViewModel().selectedArticles().length > 0) {
            this.refreshArticleResults();
        }
    }

    private convertIfObjectOfObjects(input) {
        if (Array.isArray(input)) return input;

        if (
            input !== null &&
            typeof input === 'object'
        ) {
            const result = [];
            for (var key in input) {
            if (
                Object.prototype.hasOwnProperty.call(input, key) &&
                typeof input[key] === 'object' &&
                input[key] !== null &&
                !Array.isArray(input[key])
            ) {
                result.push(input[key]);
            } else {
                // Not a pure object of objects — bail early
                return input;
            }
            }
            return result;
        }

        return input;
    }

    public enableArticlePickerWaypoint() {

        var div = document.getElementById('article-full-results-list');
        //var div = document.getElementById('article-results-list');
        let huit_neuf_this = this;

        var locked = false;
        var lastCall = 0;

        if(div) {
            div.addEventListener("scroll", function (event) {
                if(locked) return;

                if (lastCall) clearTimeout(lastCall);
                lastCall = setTimeout(() => {
                    if(huit_neuf_this) {
                        huit_neuf_this.runOnScroll(event, lastCall, locked, huit_neuf_this, div);
                    }
                }, 200);
                if (div && document.body.classList.contains("is-fixed") && div.scrollTop!= 0 && div.scrollTop + div.clientHeight >= (div.scrollHeight - 100) && !huit_neuf_this.articleNextPageRequested) {
                    if (huit_neuf_this.getTemplateViewModel().articlePagination.pageNumber() < huit_neuf_this.getTemplateViewModel().articlePagination.pageMax()) {
                        huit_neuf_this.getTemplateViewModel().articlePagination.pageNumber(huit_neuf_this.getTemplateViewModel().articlePagination.pageNumber() + 1)
                        huit_neuf_this.caller.getArticleReportList();
                        huit_neuf_this.articleNextPageRequested = true;
                    }
                }

                locked = false;
            });
            this.articleLoadEnable = true;
        }
    }

    private runOnScroll(event, lastCall, locked, huit_neuf_this, div) {

        if(locked) return;

        if (lastCall) clearTimeout(lastCall);
        lastCall = setTimeout(() => {
            if(huit_neuf_this) {
                huit_neuf_this.runOnScroll(event, lastCall, locked, huit_neuf_this);
            }
        }, 200);

        locked = false;
    }

    public setArticlePagination(totalPage, currentPage){

        this.getTemplateViewModel().articlePagination.pageMax(totalPage);
        this.getTemplateViewModel().articlePagination.pageNumber(currentPage);
    }

    public resetPagination(){

        this.getTemplateViewModel().articlePagination.pageNumber(1);
        this.getTemplateViewModel().articlePagination.pageMax(1);
        this.getTemplateViewModel().articles([]);
        this.articleLoadEnable = null;
    }

    public onClickView(data){
        if(data && data.id){
            if (this.getTemplateViewModel().selectedArticles().length > 0) {
                this.onClickSelectArticle(data);
            } else {
                this.showFullLoading();
                if(this.getBrandOverride()){
                    this.caller.getArticleByIdForRecommendation(data.id);                
                } else {
                    this.caller.getArticleById(data.id);
                }
            }
        }
    }

    protected onClickViewOnSite(permalink) {

        let brand = this.getBrand();
        this.caller.viewArticleOnSite(brand, permalink);
  }

    public showArticlePickerView(articleElement, target){
        this.setTarget(target);
        this.show();
        this.articlePickerView.restPageValues();
        this.articlePickerView.show();
        this.articlePickerView.showLoading();
        this.editArticleElement(articleElement);
    }

    public editArticleElement(articleElement){

        let insertedItems = this.caller.getArticleInsertedItems(articleElement);
        this.articlePickerView.setArticleInsertedItems(insertedItems);
        this.articlePickerView.getTemplateViewModel().articleElement(articleElement);
        this.caller.getArticleById(insertedItems.idArticle);
    }

    protected setTagFilter(tags) {

        this.tagFilter.setTags(tags);
    }

    public setIsHyperLinkModeEnabled(isHyperlinkModeEnabled: boolean) {

        this.articlePickerView.setIsHyperlinkModeEnabled(isHyperlinkModeEnabled);
    }

    protected onClickQuickInsertHyperlink(data: any) {
        if (data && data.id) {
            this.showLoading();
            this.caller.getArticleById(data.id, true);
        }
    }

    public getBrandOverride() {
        return this.getTemplateViewModel().brandOverride();
    }

    public getArticleRecommendationIndex() {
        return this.getTemplateViewModel().articleRecommendationIndex();
    }

    public clearOverrides() {

        this.getTemplateViewModel().brandOverride(null);
        this.getTemplateViewModel().sectionTitleOverride(null);
        this.getTemplateViewModel().articleRecommendationIndex(null);
    }

    public selectArticle(article) {
        let selectedArticles = this.getTemplateViewModel().selectedArticles();
        let alreadySelected = selectedArticles.find((a) => a.id === article.id);
        if (!alreadySelected) {
            selectedArticles.push(article);
        }
        this.setSelectedArticles(selectedArticles);
    }

    public selectArticles(articles) {
        for (let article of articles) {
            this.selectArticle(article);
        }
        this.loadArticleGroupElement();
        this.refreshArticleResults();
    }

    public setSelectedArticles(selectedArticles) {
        this.getTemplateViewModel().selectedArticles([]);
        this.getTemplateViewModel().selectedArticles(selectedArticles);
        this.setArticleDragHandlers();
    }

    public deselectArticle(article) {
        let selectedArticles = this.getTemplateViewModel().selectedArticles();
        selectedArticles = selectedArticles.filter((a) => a.id != article.id);
        this.setSelectedArticles(selectedArticles);
        this.refreshArticleResults();
    }

    protected onClickSelectArticle(article) {
        if (!article.selected) {
            this.caller.getArticleByIdForGroup(article.id);
        } else {
            this.deselectArticle(article);
        }

        article.selected = !article.selected;
        this.refreshArticleResults();
    }

    public refreshArticleResults() {
        let articles = this.getTemplateViewModel().articles();
        let relatedArticles = this.getTemplateViewModel().relatedArticles();
        let newModelArticles = this.getTemplateViewModel().newModelArticles();
        let selectedArticles = this.getTemplateViewModel().selectedArticles();

        for (let article of articles) {
            article.selected = selectedArticles.some((a) => a.id == article.id);
        }
        for (let article of relatedArticles) {
            article.selected = selectedArticles.some((a) => a.id == article.id);
        }
        for (let article of newModelArticles) {
            article.selected = selectedArticles.some((a) => a.id == article.id);
        }

        let scrollContainer = document.getElementById('article-full-results-list');
        let scrollTop = scrollContainer ? scrollContainer.scrollTop : 0;

        this.getTemplateViewModel().articles([]);
        this.getTemplateViewModel().articles(articles);
        this.getTemplateViewModel().relatedArticles([]);
        this.getTemplateViewModel().relatedArticles(relatedArticles);
        this.getTemplateViewModel().newModelArticles([]);
        this.getTemplateViewModel().newModelArticles(newModelArticles);

        if (scrollContainer) {
            requestAnimationFrame(() => { scrollContainer.scrollTop = scrollTop; });
        }
    }

    protected onClickInsertGroup() {
        let elementToReplace = this.getTemplateViewModel().articleGroupElement();
        if (!elementToReplace) {
            let articleElement = this.articlePickerView.getTemplateViewModel().articleElement();
            if (articleElement && articleElement.parentElement) {
                elementToReplace = articleElement;
            }
        }
        let selectedArticles = this.getTemplateViewModel().selectedArticles();

        if (selectedArticles.length < 2) {
            return;
        }

        let articleGroupElement = '<div class="emaki-displayCard-group article" contenteditable="false">';
        for (let article of selectedArticles) {
            let articleElement = this.caller.buildArticleDisplayCardElement(article);
            articleGroupElement += articleElement;
        }
        articleGroupElement += '</div>';

        this.caller.insertArticleElement(elementToReplace, articleGroupElement, this.target);
        this.articlePickerView.hide();
        this.hide();
    }

    protected onClickViewFromGroup(data) {
        this.articlePickerView.restPageValues();
        this.articlePickerView.setArticleDataFromGroup(data);
        this.articlePickerView.setIsPartOfGroup(true);
        this.articlePickerView.setGroupExists(true);
        this.articlePickerView.show();
    }

    public setArticleGroupElement(element) {
        this.getTemplateViewModel().articleGroupElement(element);
    }

    public getArticleGroupArticleElements() {
        return this.getTemplateViewModel().articleGroupArticleElements();
    }

    public setArticleGroupArticleElements(elements) {
        this.getTemplateViewModel().articleGroupArticleElements(elements);
    }

    public getArticleElementInsertedFieldsInOrder(element) {
        let idArticle = element.getAttribute("data-id");
        return { id: idArticle };
    }

    protected loadArticleGroupElement() {
        let selectedArticles = this.getTemplateViewModel().selectedArticles();
        let articleGroupElement = this.getTemplateViewModel().articleGroupElement();
        if (!articleGroupElement) {
            return;
        }
        for (let child of articleGroupElement.childNodes) {
            if (
                child.nodeName == "DIV" &&
                child.classList.contains("emaki-displayCard") &&
                child.classList.contains("article")
            ) {
                let idArticle = child.getAttribute("data-id");
                if (idArticle != null) {
                    let articleIndex = selectedArticles.findIndex((a) => a.id == idArticle);
                    if (articleIndex != -1) {
                        let insertedItems = this.caller.getArticleInsertedItems(child);
                        if (insertedItems) {
                            if (insertedItems.imageOverride) {
                                selectedArticles[articleIndex].imageOverride = insertedItems.imageOverride;
                            }
                            if (insertedItems.titleOverride) {
                                selectedArticles[articleIndex].titleOverride = insertedItems.titleOverride;
                            }
                            if (insertedItems.excerptOverride) {
                                selectedArticles[articleIndex].excerptOverride = insertedItems.excerptOverride;
                            }
                            if (insertedItems.viewType) {
                                selectedArticles[articleIndex].viewType = insertedItems.viewType;
                            }
                            if (insertedItems.label) {
                                selectedArticles[articleIndex].label = insertedItems.label;
                            }
                        }
                    }
                }
            }
        }
        this.setSelectedArticles(selectedArticles);
    }

    public clearGroupState() {
        this.getTemplateViewModel().selectedArticles([]);
        this.getTemplateViewModel().articleGroupElement(null);
        this.getTemplateViewModel().articleGroupArticleElements([]);
        this.articlePickerView.setIsPartOfGroup(false);
        this.articlePickerView.setGroupExists(false);
    }

    private setArticleDragHandlers() {
        var parent = this;
        var dragSrcEl = null;

        function handleDragStart(e) {
            dragSrcEl = this;
            e.dataTransfer.effectAllowed = "move";
            e.dataTransfer.setData("text/html", this.outerHTML);
            this.classList.add("dragElem");
            return false;
        }

        function handleDragOver(e) {
            if (e.preventDefault) {
                e.preventDefault();
            }
            this.style.cursor = "grab";

            var dragItems = document.querySelectorAll(".article-group-sortable .picker-item");
            let index = 0;
            let found = false;
            for (let item of dragItems) {
                if (item == dragSrcEl) {
                    found = true;
                }
                if (item == this) {
                    if (found) {
                        this.classList.remove("before");
                        this.classList.add("after");
                    } else {
                        this.classList.remove("after");
                        this.classList.add("before");
                    }
                    found = true;
                    break;
                }
            }

            if (!found) {
                this.classList.add("before");
            }

            e.dataTransfer.dropEffect = "move";
            return false;
        }

        function handleDragEnter(e) {}

        function handleDragLeave(e) {
            this.classList.remove("before");
            this.classList.remove("after");
        }

        function handleDrop(e) {
            if (e.stopPropagation) {
                e.stopPropagation();
            }
            if (e.preventDefault) {
                e.preventDefault();
            }

            if (dragSrcEl != this) {
                var dropHTML = e.dataTransfer.getData("text/html");
                if (dropHTML.includes("<li")) {
                    for (let child of this.parentNode.childNodes) {
                        if (child == dragSrcEl) {
                            this.parentNode.removeChild(dragSrcEl);
                        }
                    }

                    if (this.classList.contains("before")) {
                        this.insertAdjacentHTML("beforebegin", dropHTML);
                        var dropElem = this.previousElementSibling;
                    } else {
                        this.insertAdjacentHTML("afterend", dropHTML);
                        var dropElem = this.nextElementSibling;
                    }

                    addDnDHandlers(dropElem);
                }
            }
            parent.reorderArticles();
            this.classList.remove("before");
            this.classList.remove("after");
            return false;
        }

        function handleDragEnd(e) {
            this.classList.remove("before");
            this.classList.remove("after");
            [].forEach.call(cols, function (col) {
                col.classList.remove("before");
                col.classList.remove("after");
            });
        }

        function addDnDHandlers(elem) {
            elem.addEventListener("dragstart", handleDragStart, false);
            elem.addEventListener("dragenter", handleDragEnter, false);
            elem.addEventListener("dragover", handleDragOver, false);
            elem.addEventListener("dragleave", handleDragLeave, false);
            elem.addEventListener("drop", handleDrop, false);
            elem.addEventListener("dragend", handleDragEnd, false);
        }

        var cols = document.querySelectorAll(".article-group-sortable .picker-item");
        [].forEach.call(cols, addDnDHandlers);
    }

    protected reorderArticles() {
        let selectedArticles = this.getTemplateViewModel().selectedArticles();
        let liElements = document.querySelectorAll(".article-group-sortable .picker-item");

        let newArticles = [];
        for (let element of liElements) {
            let idElement = element.id.replace('article-group-', '');
            let article = selectedArticles.find((a) => a.id == idElement || a.id === Number(idElement));
            if (article) {
                newArticles.push(article);
            }
        }
        this.setSelectedArticles(newArticles);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/articlePicker_template.ts